export default __webpack_public_path__ + "static/media/topImg.9317953d.png";